import React, { useMemo, useState } from 'react';
import CalculatorIcon from "../node/img/calculator.png";
import CovidIcon from "../node/img/covid.png";
import QuoteIcon from "../node/img/quote.png";
import BlockIcon from "../node/img/blockchain.png";
import GradeIcon from "../node/img/grade.png";
import NewsIcon from "../node/img/news.png";
import UrgentCareIcon from "../node/img/urgentcare.png";
import StoreIcon from "../node/img/store.png";
import Card from "./Card";

const PAGE_SIZE = 6;

const projects = [
  {
    image: CalculatorIcon,
    title: {
      name: 'Calculator App',
      description: 'Simple and cute react calculator with basic functions.',
      status: 'Live',
      website: '/calculator',
      github: 'https://github.com/kennashka/calculator'
    }
  },
  {
    image: CovidIcon,
    title: {
      name: 'Covid-19 App',
      description: 'COVID-19 dashboard using the disease.sh API to display global and country-level stats.',
      status: 'Live',
      website: '/covid',
      github: 'https://github.com/kennashka/covid-19'
    }
  },
  {
    image: QuoteIcon,
    title: {
      name: 'To Do/Reminder App',
      description: 'To do List App made with react.',
      status: 'Live',
      website: '/todo',
      github: 'https://github.com/kennashka/reminder-app'
    }
  },
  {
    image: BlockIcon,
    title: {
      name: 'Stacks Blockchain Security',
      description: 'Stacks Security Center implements blockchain transaction observability best practices to offer accessible financial threat detection alerts.',
      status: 'In Development',
      website: '/stacks',
      github: 'https://github.com/kennashka'
    }
  },
  {
    image: GradeIcon,
    title: {
      name: 'Grade Average App',
      description: 'A Node.js project that calculates the average of three grades.',
      status: 'Live',
      website: '/grade',
      github: 'https://github.com/kennashka/grade-average-calculation'
    }
  },
  {
    image: NewsIcon,
    title: {
      name: 'News App',
      description: 'React news app with search functionality using hacker news api',
      status: 'In Development',
      website: '/news',
      github: 'https://github.com/kennashka/react-news-app'
    }
  },
  {
    image: UrgentCareIcon,
    title: {
      name: 'Hialeah Urgent Care',
      description: 'Whitepaper on how to secure an urgent care',
      status: 'In Development',
      website: '/urgentcare',
      github: '/#'
    }
  },
  {
    image: StoreIcon,
    title: {
      name: 'Store (In Dev)',
      description: 'Kenya Ecommerce Store',
      status: 'In Development',
      website: 'http://store.kennashka.com',
      github: '/#'
    }
  },
  {
    image: CalculatorIcon,
    title: {
      name: 'Binary Calculator',
      description: 'Binary calculator for AND, OR, XOR, and decimal conversion.',
      status: 'Live',
      website: '/binary-calculator',
      github: '/#'
    }
  },
];

const Projects = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(projects.length / PAGE_SIZE);

  const pagedProjects = useMemo(() => {
    const start = (currentPage - 1) * PAGE_SIZE;
    return projects.slice(start, start + PAGE_SIZE);
  }, [currentPage]);

  return (
    <div>
      <div data-reactroot className="row">
        {pagedProjects.map((project) => (
          <Card
            key={project.title.name}
            CardImage={project.image}
            appTitle={project.title}
          />
        ))}
      </div>

      <div className="d-flex justify-content-center align-items-center pb-3">
        <button
          type="button"
          className="btn btn-light mr-2"
          onClick={() => setCurrentPage((page) => Math.max(1, page - 1))}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        <span className="mx-2">Page {currentPage} of {totalPages}</span>
        <button
          type="button"
          className="btn btn-light ml-2"
          onClick={() => setCurrentPage((page) => Math.min(totalPages, page + 1))}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Projects;
